<template>
  <div class="balance-block-content">
    <img
      class="balance-bg"
      src="../../picture/img/recharge-balance.png"
      alt=""
      mode="widthFix"
      style="width: 100%"
    />
    <div class="balance-content">
      <div class="balance-title" @click="moneyTips">
        {{ title ? title : "可用余额(元)" }}
        <img
          class="wen"
          v-if="titleTips"
          src="../../picture/image/wen-white.png"
        />
      </div>
      <div class="balance-all">{{ accountObj.availableAmount || 0 }}</div>
      <div class="other-money-box">
        <div class="other-money-flex" v-if="balanceAmount">
          余额(元)：{{ accountObj.balanceAmount || 0 }}
        </div>
        <div class="other-money-flex">
          冻结金额(元)：{{ accountObj.frozenAmount || 0 }}
        </div>
      </div>
      <div class="balance-btn" v-if="btnName" @click="balanceClick">
        {{ btnName }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pi-balance-block",
  data() {
    return {
      className: "",
    };
  },
  methods: {
    balanceClick() {
      this.$emit("btnClick");
    },
    moneyTips() {
      if (this.titleTips) {
        this.$router.push("/money-tips");
      }
    },
  },
  mounted() {},
  props: {
    accountObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    btnName: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    titleTips: {
      type: Boolean,
      default: true,
    },
    balanceAmount: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="less" scoped>
.balance-block-content {
  color: #fff;
  font-size: 0.3rem;
  line-height: 0.42rem;
  background: linear-gradient(90deg, #ff9a37 0%, #ffca24 100%);
  box-shadow: 0px 0px 0.23rem -0.02rem rgba(255, 154, 55, 0.2);
  border-radius: 0.16rem;
  height: 2.7rem;
}
.balance-bg {
  width: 100%;
  height: 100%;
}
.balance-block-content {
  position: relative;
}
.balance-content {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  padding: 0.2rem;
  box-sizing: border-box;
}
.balance-content .balance-title .wen {
  width: 0.42rem;
  height: 0.42rem;
  display: inline-block;
  vertical-align: text-top;
}
.balance-content .balance-all {
  margin-top: 0.25rem;
  font-size: 0.8rem;
  line-height: 0.97rem;
  font-weight: bold;
}
.balance-content .other-money-box {
  display: flex;
  margin-top: 0.24rem;
}
.balance-content .other-money-flex {
  flex: 1;
}
.balance-content .other-money-flex:last-child {
  text-align: right;
}
.balance-btn {
  background: #ffffff;
  border-radius: 0.28rem;
  font-size: 0.3rem;
  font-weight: 400;
  color: #ff9a37;
  line-height: 0.42rem;
  padding: 0.06rem 0.21rem;
  position: absolute;
  right: 0.2rem;
  top: 0.2rem;
}
</style>
